import PolygonBase from './PolygonBase';
import shapeSquareSVG from '../assets/icons/shapeSquare.svg';
import { svgToIcon } from '../utils/svg';

class ShapeRect extends PolygonBase {
  static renderIcon() {
    return svgToIcon(shapeSquareSVG);
  }

  static pathString() {
    return `
      M -0.5 -0.5
      L 0.5 -0.5
      L 0.5 0.5
      L -0.5 0.5
      Z
    `;
  }
}

export default ShapeRect;
